import React, { CSSProperties } from "react";

interface LineLoginButtonExportProps {
  liffId?: string;
  apiHost?: string;
  appName?: string;
  buttonText?: string;
  loggedInText?: string;
  style?: "green" | "white";
  size?: "small" | "medium" | "large";
  borderRadius?: number;
  redirectUrl?: string;
  showUserName?: boolean;
}

const LINE_GREEN = "#06C755";

export const LineLoginButtonExport: React.FC<LineLoginButtonExportProps> = ({
  liffId = "",
  apiHost = "",
  appName = "",
  buttonText = "เข้าสู่ระบบด้วย LINE",
  style = "green",
  size = "medium",
  borderRadius = 8,
  redirectUrl = "",
}) => {
  const sizeConfig = {
    small: { px: 12, py: 6, fontSize: 12, iconSize: 16 },
    medium: { px: 16, py: 8, fontSize: 14, iconSize: 20 },
    large: { px: 24, py: 12, fontSize: 16, iconSize: 24 },
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  const isGreen = style === "green";

  const buttonStyles: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: `${config.py}px ${config.px}px`,
    fontSize: `${config.fontSize}px`,
    fontWeight: 600,
    fontFamily: "inherit",
    borderRadius: `${borderRadius}px`,
    cursor: "pointer",
    whiteSpace: "nowrap",
    backgroundColor: isGreen ? LINE_GREEN : "#ffffff",
    color: isGreen ? "#ffffff" : LINE_GREEN,
    border: isGreen ? "none" : `2px solid ${LINE_GREEN}`,
    textDecoration: "none",
    transition: "opacity 0.2s",
  };

  return (
    <button
      className="line-login-btn"
      style={buttonStyles}
      data-element="line-login"
      data-type="action"
      data-liff-id={liffId}
      data-api-host={apiHost}
      data-app-name={appName}
      data-redirect-url={redirectUrl}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={config.iconSize}
        height={config.iconSize}
        fill="currentColor"
      >
        <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.349 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
      </svg>
      <span>{buttonText}</span>
    </button>
  );
};
